import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header_container" }
const _hoisted_2 = { class: "header-title__container" }
const _hoisted_3 = { class: "header_left" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "header_left_content" }, "4PL物流协同平台", -1)
const _hoisted_5 = { class: "header_right" }
const _hoisted_6 = { class: "el-dropdown-link" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_HeaderTabs = _resolveComponent("HeaderTabs")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_UpdPassWord = _resolveComponent("UpdPassWord")!
  const _component_BindMobile = _resolveComponent("BindMobile")!
  const _component_WMSClientDialog = _resolveComponent("WMSClientDialog")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_SvgIcon, {
          size: "150 18",
          name: "logo-large",
          style: {"color":"#fff"}
        }),
        _hoisted_4,
        _createVNode(_component_HeaderTabs, { value: _ctx.tabsActiveIndex }, {
          default: _withCtx(() => [
            _createVNode(_component_TabPanel, {
              name: "Home",
              label: "平台介绍",
              disabled: false,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/home')))
            }),
            _createVNode(_component_TabPanel, {
              name: "DataBoard",
              label: "数据看板",
              disabled: !_ctx.hasRoutePermission('DataBoard'),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/view-data-board/data-board'))),
              onDisabledClick: _ctx.hasnotPermissionHandle
            }, null, 8, ["disabled", "onDisabledClick"]),
            _createVNode(_component_TabPanel, {
              name: "OverdueDataBoard",
              label: "超时看板",
              disabled: !_ctx.hasRoutePermission('OverdueDataBoard'),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/view-data-board/overdue-data-board'))),
              onDisabledClick: _ctx.hasnotPermissionHandle
            }, null, 8, ["disabled", "onDisabledClick"]),
            _createVNode(_component_TabPanel, {
              name: "BDSMain",
              label: "数字大屏",
              disabled: !_ctx.hasRoutePermission('BDSMain'),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/big-data-service/bds-mian'))),
              onDisabledClick: _ctx.hasnotPermissionHandle
            }, null, 8, ["disabled", "onDisabledClick"])
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_dropdown, { class: "system-center__button__wrap" }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_dropdown_item, {
                  disabled: !_ctx.hasApplicationPermission('Ods'),
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openSystemByCode('ODS')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SvgIcon, {
                      name: "ods-menu",
                      class: "menu-icon__wrap",
                      size: "24 24"
                    }),
                    _createTextVNode("ODS")
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_el_dropdown_item, { onClick: _ctx.openWMSClient }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SvgIcon, {
                      name: "wms-menu",
                      class: "menu-icon__wrap",
                      size: "24 24"
                    }),
                    _createTextVNode("WMS")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_dropdown_item, {
                  disabled: !_ctx.hasApplicationPermission('TMS'),
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openSystemByCode('TMS')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SvgIcon, {
                      name: "tms-menu",
                      class: "menu-icon__wrap",
                      size: "24 24"
                    }),
                    _createTextVNode("TMS")
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_el_dropdown_item, {
                  disabled: !_ctx.hasApplicationPermission('BMS'),
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openSystemByCode('BMS')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SvgIcon, {
                      name: "bms-menu",
                      class: "menu-icon__wrap",
                      size: "24 24"
                    }),
                    _createTextVNode("BMS ")
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_el_dropdown_item, {
                  disabled: !_ctx.hasApplicationPermission('Permissions'),
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openSystemByCode('PMS')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SvgIcon, {
                      name: "pms-menu",
                      class: "menu-icon__wrap",
                      size: "24 24"
                    }),
                    _createTextVNode("PMS")
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_el_dropdown_item, {
                  disabled: !_ctx.hasApplicationPermission('CSP'),
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.openSystemByCode('CSP')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SvgIcon, {
                      name: "csp-menu",
                      class: "menu-icon__wrap",
                      size: "24 24"
                    }),
                    _createTextVNode("CSP")
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_el_dropdown_item, {
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.openSystemByCode('FPL')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SvgIcon, {
                      name: "fpl-menu",
                      class: "menu-icon__wrap",
                      size: "24 16"
                    }),
                    _createTextVNode("ITSM")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_dropdown_item, {
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.openSystemByCode('FPL-WECHAT')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SvgIcon, {
                      name: "wechat",
                      class: "menu-icon__wrap",
                      size: "24 16"
                    }),
                    _createTextVNode("小程序运营后台")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_dropdown_item, {
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.openSystemByCode('FPL-EXPRESS')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SvgIcon, {
                      name: "truck-fast",
                      class: "menu-icon__wrap",
                      size: "24 16"
                    }),
                    _createTextVNode("快递平台")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_button, { type: "primary" }, {
              default: _withCtx(() => [
                _createTextVNode(" 应用中心 ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_popover, {
          placement: "bottom",
          width: 300,
          trigger: "hover",
          "popper-style": { padding: '5px 5px 0px 5px' }
        }, {
          reference: _withCtx(() => [
            _createVNode(_component_SvgIcon, {
              class: "lightning",
              name: "lightning",
              size: "19 19",
              onClick: _ctx.onLightningClick
            }, null, 8, ["onClick"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_image, {
              style: {"width":"100%","cursor":"pointer"},
              src: `${_ctx.FILESERVICE}/file/4pl/webclient/img/it_bing_banner.png`,
              fit: "fill",
              onClick: _ctx.onLightningClick
            }, null, 8, ["src", "onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_SvgIcon, {
          class: "login-img",
          name: "Login-Icon",
          size: "14 19"
        }),
        _createVNode(_component_el_dropdown, { class: "dropdown-title" }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_dropdown_item, { onClick: _ctx.openPassword }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 修改密码 ")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_dropdown_item, { onClick: _ctx.bindMobile }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 绑定手机 ")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_dropdown_item, { onClick: _ctx.logout }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 退出登录 ")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createTextVNode(" Hi, " + _toDisplayString(_ctx.userStore.getUserName) + " ", 1),
              _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                default: _withCtx(() => [
                  _createVNode(_component_arrow_down)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_el_dialog, {
      ref: "dialogForm",
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      width: "460px",
      top: "150px",
      "append-to-body": "",
      "destroy-on-close": "",
      class: _normalizeClass({ 'dialog--wms-client': _ctx.visibleDialogName === 'WMS-client' }),
      "show-close": false,
      onClose: _ctx.onDialogClose
    }, {
      default: _withCtx(() => [
        (_ctx.visibleDialogName === 'update-password')
          ? (_openBlock(), _createBlock(_component_UpdPassWord, {
              key: 0,
              username: _ctx.userStore.getUserName,
              onCloseDia: _ctx.onDialogClose
            }, null, 8, ["username", "onCloseDia"]))
          : (_ctx.visibleDialogName === 'bind-mobile')
            ? (_openBlock(), _createBlock(_component_BindMobile, {
                key: 1,
                onCloseDia: _ctx.onDialogClose
              }, null, 8, ["onCloseDia"]))
            : (_ctx.visibleDialogName === 'WMS-client')
              ? (_openBlock(), _createBlock(_component_WMSClientDialog, {
                  key: 2,
                  username: _ctx.userStore.getUserName,
                  onCloseDia: _ctx.onDialogClose
                }, null, 8, ["username", "onCloseDia"]))
              : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "class", "onClose"])
  ]))
}